import type { RouteRecord } from 'vite-react-ssg';
import { Layout } from './Layout';

// Direct imports for SSG compatibility (lazy loading doesn't work with SSR)
import { Index } from './pages/Index';
import { About } from './pages/About';
import { Pricing } from './pages/Pricing';
import { FAQ } from './pages/FAQ';
import { Resources } from './pages/Resources';
import { Gallery } from './pages/Gallery';
import { Training } from './pages/Training';
import { TailwheelEndorsement } from './pages/training/TailwheelEndorsement';
import { CfiSpinTraining } from './pages/training/CfiSpinTraining';
import { TailwheelRefresh } from './pages/training/TailwheelRefresh';
import { FlightReview } from './pages/training/FlightReview';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { loadBlogPosts } from './utils/blogParser';

// Helper function to wrap components with Layout
function withLayout(Component: React.ComponentType) {
  return () => (
    <Layout>
      <Component />
    </Layout>
  );
}

// Define all routes for SSG
export const routes: RouteRecord[] = [
  { path: '/', Component: withLayout(Index) },
  { path: '/about', Component: withLayout(About) },
  { path: '/pricing', Component: withLayout(Pricing) },
  { path: '/faq', Component: withLayout(FAQ) },
  { path: '/resources', Component: withLayout(Resources) },
  { path: '/gallery', Component: withLayout(Gallery) },
  { path: '/training', Component: withLayout(Training) },
  { path: '/training/tailwheel-endorsement', Component: withLayout(TailwheelEndorsement) },
  { path: '/training/cfi-spin-training', Component: withLayout(CfiSpinTraining) },
  { path: '/training/tailwheel-refresh', Component: withLayout(TailwheelRefresh) },
  { path: '/training/flight-review', Component: withLayout(FlightReview) },
  { path: '/blog', Component: withLayout(Blog) },
  ...loadBlogPosts().map((post) => ({
    path: `/blog/${post.slug}`,
    Component: withLayout(BlogPost),
  })),
  { path: '/inquire', Component: withLayout(Contact) },
  { path: '/contact', Component: withLayout(Contact) },
];